import React, { useEffect, useState } from 'react';
import { get, orderBy } from 'lodash';
import axios from 'axios';
import Loading from '../Loading';

const GiftsSummary = ({
  endpoint,
  title
}) => {
  const [isLoading, setLoading] = useState(true)
  const [giftsSummary, setGiftsSummary] = useState([])

  useEffect(() => {
    axios.get(endpoint)
      .then((res) => {
        if (res.status == 200 && get(res, 'data.gifts')) {
          setGiftsSummary(sortSummary(res.data.gifts))
          setLoading(false)
        }
    })
  }, [])

  const sortSummary = (gifts) => {
    return orderBy(gifts, ['items_count'], ['desc'])
  }

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>{title}</h3>
      </div>

      <div className='Table Table--gifts-summary'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Gift ID</div>
          <div className='Table__col Table__col--th'>Gift Type</div>
          <div className='Table__col Table__col--th'>Total Amount</div>
        </div>
        <Loading
          isLoading={isLoading && giftsSummary.length == 0}
        >
          {giftsSummary.map((gift) => (
            <div key={gift.id} className='Table__row'>
              <div className='Table__col'>#{gift.id}</div>
              <div className='Table__col'>{`${gift.title} (${gift.currency})`}</div>
              <div className='Table__col'>{gift.items_count}</div>
            </div>
          ))}
          {giftsSummary.length == 0 && <div className='Table__row'>
            <div className='Table__col'>
              Nothing to show yet
            </div>
          </div>}
        </Loading>
      </div>
    </React.Fragment>
  )
}

export default GiftsSummary
